function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import uniqueId from "lodash-es/uniqueId";
import { PROPS_KEY } from "../schema/type";
import { REACTION_KEY } from "./type";
import { createStringPath } from "../../fieldPath";
import { FieldEffectApiMap, getDepByPath, getFieldByPath, getStringPath, MarkupPropToFieldState } from "./utils";
import { DataMapType } from "../DataMapper/type";
function applyDefaultComponentProps(componentPropsMap, markupProps, type) {
  const MARKUP_COMPONENT_KEY = `x-${type}`;
  const MARKUP_COMPONENT_PROPS_KEY = `x-${type}-props`;
  const component = markupProps[MARKUP_COMPONENT_KEY];
  if (!component) {
    return;
  }
  const propsGenerator = componentPropsMap[component];
  if (!propsGenerator) {
    return;
  }
  const defaultComponentProps = propsGenerator(markupProps);
  if (!defaultComponentProps || typeof defaultComponentProps !== "object" || !Object.keys(defaultComponentProps).length) {
    return;
  }
  const baseComponentProps = markupProps[MARKUP_COMPONENT_PROPS_KEY];
  if (!baseComponentProps || typeof baseComponentProps !== "object") {
    markupProps[MARKUP_COMPONENT_PROPS_KEY] = defaultComponentProps;
  } else {
    markupProps[MARKUP_COMPONENT_PROPS_KEY] = _object_spread({}, defaultComponentProps, baseComponentProps);
  }
}
export function toReactionCollection(reaction, currentPath, context) {
  var _context;
  var _context_commonDepPaths;
  const commonDepPaths = (_context_commonDepPaths = (_context = context) === null || _context === void 0 ? void 0 : _context.commonDepPaths) !== null && _context_commonDepPaths !== void 0 ? _context_commonDepPaths : [];
  const { deps: depPaths = [], untrackedDeps: untrackedDepPaths = [], effects: originEffects = [], target: targetPath, targets: targetPaths = [], targetAttr, reactor, schema, state } = reaction;
  const allTargetPaths = [
    targetPath,
    ...targetPaths
  ].filter((p) => p !== void 0);
  let actualFieldPaths = [];
  let effects;
  let actualTargetPaths = [];
  if (originEffects.length) {
    effects = [
      ...originEffects
    ];
    if (allTargetPaths.length) {
      if (currentPath) {
        actualFieldPaths = [
          currentPath
        ];
      } else {
        actualFieldPaths = [
          ...depPaths
        ];
      }
      actualTargetPaths = [
        ...allTargetPaths
      ];
    } else {
      actualFieldPaths = [
        ...commonDepPaths,
        ...depPaths
      ];
      if (currentPath) {
        actualTargetPaths = [
          currentPath
        ];
      }
    }
  } else {
    effects = [
      "onFieldReact"
    ];
    if (allTargetPaths.length) {
      actualFieldPaths = [
        ...allTargetPaths
      ];
      actualTargetPaths = [
        ...allTargetPaths
      ];
    } else if (currentPath) {
      actualFieldPaths = [
        currentPath
      ];
      actualTargetPaths = [
        currentPath
      ];
    }
  }
  const reactorCollections = [];
  if (reactor) {
    reactorCollections.push({
      schemaKey: targetAttr,
      reactor
    });
  }
  if (state) {
    for (const entry of Object.entries(state)) {
      const [key, currentReactor] = entry;
      reactorCollections.push({
        stateKey: key,
        reactor: currentReactor
      });
    }
  }
  if (schema) {
    for (const entry of Object.entries(schema)) {
      const [key, currentReactor] = entry;
      reactorCollections.push({
        schemaKey: key,
        reactor: currentReactor
      });
    }
  }
  return {
    currentPath,
    depPaths,
    untrackedDepPaths,
    effects,
    targetPath,
    targetPaths,
    actualFieldPaths,
    actualTargetPaths,
    reactorCollections
  };
}
function applyReactorResult(reactorCollection, field, result) {
  const { schemaKey, stateKey } = reactorCollection;
  if (stateKey) {
    field[stateKey] = result;
  } else if (schemaKey) {
    const toFieldState = MarkupPropToFieldState[schemaKey];
    if (toFieldState) {
      if (typeof toFieldState === "function") {
        toFieldState(field, result);
      } else {
        field[toFieldState] = result;
      }
    }
  }
}
function generateReactionExcutor(reactionCollection, context) {
  var _context, _context1, _context2;
  const { currentPath, depPaths, untrackedDepPaths, targetPath, targetPaths, actualTargetPaths, reactorCollections } = reactionCollection;
  var _context_commonDepPaths;
  const commonDepPaths = (_context_commonDepPaths = (_context = context) === null || _context === void 0 ? void 0 : _context.commonDepPaths) !== null && _context_commonDepPaths !== void 0 ? _context_commonDepPaths : [];
  var _context_commonUntrackedDepPaths;
  const commonUntrackedDepPaths = (_context_commonUntrackedDepPaths = (_context1 = context) === null || _context1 === void 0 ? void 0 : _context1.commonUntrackedDepPaths) !== null && _context_commonUntrackedDepPaths !== void 0 ? _context_commonUntrackedDepPaths : [];
  var _context_scope;
  const scope = (_context_scope = (_context2 = context) === null || _context2 === void 0 ? void 0 : _context2.scope) !== null && _context_scope !== void 0 ? _context_scope : {};
  const excutor = (f, form) => {
    const baseStringPath = f.address.toString();
    const commonDeps = commonDepPaths.map((path) => getDepByPath(path, form, {
      baseStringPath
    }));
    const commonUntrackedDeps = commonUntrackedDepPaths.map((path) => getDepByPath(path, form, {
      baseStringPath,
      isUntracked: true
    }));
    const deps = depPaths.map((path) => getDepByPath(path, form, {
      baseStringPath
    }));
    const untrackedDeps = untrackedDepPaths.map((path) => getDepByPath(path, form, {
      baseStringPath,
      isUntracked: true
    }));
    const target = targetPath ? getFieldByPath(targetPath, form, {
      baseStringPath
    }) : void 0;
    const targets = targetPaths.map((path) => getFieldByPath(path, form, {
      baseStringPath
    }));
    const self = currentPath ? getFieldByPath(currentPath, form, {
      baseStringPath
    }) : void 0;
    for (const currentTargetPath of actualTargetPaths) {
      const field = getFieldByPath(currentTargetPath, form, {
        baseStringPath
      });
      if (!field) {
        continue;
      }
      for (const reactorCollection of reactorCollections) {
        const { reactor: currentReactor } = reactorCollection;
        const result = currentReactor({
          commonDeps,
          commonUntrackedDeps,
          deps,
          untrackedDeps,
          self,
          target,
          targets,
          form,
          scope
        });
        if (result instanceof Promise) {
          var _field_setLoading, _field;
          (_field_setLoading = (_field = field).setLoading) === null || _field_setLoading === void 0 ? void 0 : _field_setLoading.call(_field, true);
          result.then((res) => {
            applyReactorResult(reactorCollection, field, res);
          }).finally(() => {
            var _field_setLoading2, _field2;
            (_field_setLoading2 = (_field2 = field).setLoading) === null || _field_setLoading2 === void 0 ? void 0 : _field_setLoading2.call(_field2, false);
          });
        } else {
          applyReactorResult(reactorCollection, field, result);
        }
      }
    }
  };
  return excutor;
}
export function generateFormEffects(reactions, currentPath, effectorContext) {
  const effctor = () => {
    for (const reaction of reactions) {
      const reactionCollection = toReactionCollection(reaction, currentPath, effectorContext);
      const { effects, actualFieldPaths } = reactionCollection;
      for (const effect of effects) {
        for (const fieldPath of actualFieldPaths) {
          FieldEffectApiMap[effect](getStringPath(fieldPath, {
            baseStringPath: currentPath && getStringPath(currentPath)
          }), generateReactionExcutor(reactionCollection, effectorContext));
        }
      }
    }
  };
  return effctor;
}
export function transformMarkupProps(easyProps, componentKey, context, dataMapper, componentPropsMap) {
  var _window_traceRelation, _window;
  const { form, scope, parentInfo: { path: parentPath, isArrayField: isParentArrayField } } = context;
  let currentPath, dataMap;
  let commonDepPaths = [];
  let commonUntrackedDepPaths = [];
  const reactions = [];
  const baseProps = {};
  for (const [key, value] of Object.entries(easyProps)) {
    if (value === void 0) {
      continue;
    }
    if (key === PROPS_KEY.path) {
      currentPath = value;
    } else if (key === PROPS_KEY.dataMap) {
      if (typeof value === "string" && Object.values(DataMapType).includes(value)) {
        dataMap = {
          type: value
        };
      } else {
        dataMap = value;
      }
    } else if (key === PROPS_KEY.commonDeps) {
      commonDepPaths = value;
    } else if (key === PROPS_KEY.commonUntrackedDeps) {
      commonUntrackedDepPaths = value;
    } else if (key === PROPS_KEY.actions) {
      if (typeof value === "function") {
        reactions.push({
          reactor: value
        });
      } else if (Array.isArray(value)) {
        reactions.push(...value);
      } else {
        reactions.push(value);
      }
    } else if (typeof value === "function") {
      reactions.push({
        targetAttr: key,
        reactor: value
      });
    } else if (typeof value === "object" && Object.hasOwn(value, REACTION_KEY.reactor)) {
      reactions.push(_object_spread({
        targetAttr: key
      }, value));
    } else {
      baseProps[key] = value;
    }
  }
  if (baseProps.name === void 0 && currentPath === void 0) {
    if (isParentArrayField && componentKey === "Object") {
      currentPath = parentPath.item();
    } else {
      baseProps.name = uniqueId("EASY_NO_NAME_FIELD_$");
      currentPath = createStringPath(parentPath, baseProps.name);
    }
  } else if (baseProps.name !== void 0 && currentPath === void 0) {
    currentPath = createStringPath(parentPath, String(baseProps.name));
  } else if (baseProps.name === void 0 && currentPath !== void 0) {
    baseProps.name = currentPath.refPropsName();
  }
  const nextParentInfo = {
    path: currentPath,
    isArrayField: componentKey === "Array"
  };
  if (baseProps["x-component"] === "ArrayTable.Column") {
    nextParentInfo.path = parentPath;
  }
  if (currentPath) {
    currentPath.clear();
    if (componentKey === "Void") {
      currentPath.setVoid();
    }
    if (dataMap) {
      dataMapper.collectDataMap(form, {
        path: currentPath,
        dataMap
      });
    }
  } else {
    console.error("[EasyFormily Error]当前 field 缺少 path");
  }
  if (componentPropsMap) {
    applyDefaultComponentProps(componentPropsMap, baseProps, "decorator");
    applyDefaultComponentProps(componentPropsMap, baseProps, "component");
  }
  if (!reactions.length || !currentPath) {
    return [
      null,
      nextParentInfo,
      baseProps
    ];
  }
  (_window_traceRelation = (_window = window).traceRelation) === null || _window_traceRelation === void 0 ? void 0 : _window_traceRelation.call(_window, form, currentPath, commonDepPaths, reactions);
  const effectorContext = {
    commonDepPaths,
    commonUntrackedDepPaths,
    scope
  };
  const effctor = generateFormEffects(reactions, currentPath, effectorContext);
  return [
    {
      id: `$SCHEMA_FIELD_COMPONENT_EFFECTS_${currentPath.refPropsPath()}`,
      effects: effctor
    },
    nextParentInfo,
    baseProps
  ];
}
